import React from 'react';
import classes from "./TableWrapper.module.scss";

const TableWrapper = ({children}) => {
    return (
        <div className={classes.Container}>
            {children}
        </div>
    );
};

export default TableWrapper;